import {MercanciaActionTypes, SAVE_MERCANCIAS} from "../types/mercanciaActionTypes";
import { MercanciaDatosComplementarios } from "../../entities/solicitudes/MercanciaDatosComplementarios";
import { MercanciaDatosComplementariosActionTypes, SAVE_MERCANCIASCOMPLEMENTARIO } from "../types/mercanciaDatosComplementariosActionTypes";

export const initialMercanciaComplementaria: MercanciaDatosComplementarios = new MercanciaDatosComplementarios({
    id: 1,
    claveUnidad: {},
    claveUnidadId:'',
    claveProducto:{},
    claveProductoId: '',
    claveFraccionArancelaria : {},
    claveFraccionArancelariaId:'',
    descripcionMercancia: '',
    uuidComprobante: '',
    peso: 0,
    esFormaValida: false,
    camposRequeridos: [],
    camposInvalidos: [],
    cantidad: 0,
});

const initialState: MercanciaDatosComplementarios[] = [];

export function mercanciaDatosComplementariosReducer(state = initialState, action: MercanciaDatosComplementariosActionTypes): MercanciaDatosComplementarios[] {
    switch (action.type) {
        case SAVE_MERCANCIASCOMPLEMENTARIO:
            return action.mercanciasDatosComplementarios;
        default:
            return state;
    }
}
